import gql from 'graphql-tag'

export default gql`
  mutation editUserProfile(
    $id: ID!
    $name: String!
    $phone: String!
    $email: String!
    $cpf: String!
    $creci: String!
    $type: String!
    $districts: [String]!
    $utm: InputUtm
  ) {
    editUserProfile(
      id: $id
      name: $name
      phone: $phone
      cpf: $cpf
      creci: $creci
      type: $type
      utm: $utm
    ) {
      id
      name
      phone
      cpf
      creci
      type
      role
    }
    changeEmail(id: $id, email: $email) {
      email
    }
    editPartnerDistricts(id: $id, districts: $districts) {
      id
      districts {
        uuid
      }
    }
  }
`
